import { AccountProps } from 'screens/Schedule/EditChannelsModal/Types'
import Styles from './Account.module.scss'
import { getIntegrationDetails } from 'components/Previews/getIntegrationDetails'
import { Text } from 'blaze-ui/Text/Text'
import { getInitials } from 'utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import Avatar from 'common/Avatar/Avatar'
import React from 'react'
import { ProviderIcon } from 'blaze-ui/icons/ProviderIcon'

export const AccountImage = ({ integration, size = 20 }: AccountProps) => {
  const { picture, name } = getIntegrationDetails(integration)

  return (
    <div className={Styles.accountImage}>
      <Avatar size={size} label={getInitials(name)} url={picture || Silhouette} />
      <div className={Styles.providerIcon}>
        <ProviderIcon provider={integration.provider} size={size - 8} />
      </div>
    </div>
  )
}

export const Account = (props: AccountProps) => {
  const { name } = getIntegrationDetails(props.integration)
  return (
    <div className={Styles.wrapper}>
      <AccountImage {...props} />
      <Text variant="placeholder" color="var(--dark-80)">
        {name}
      </Text>
    </div>
  )
}
